import * as lodash from 'lodash'

export const bdcHotelPropertyClassTypes = [
  { code: 30, name: 'Resort' },
  { code: 19, name: 'Hostel' },
  { code: 20, name: 'Hotel' },
  { code: 21, name: 'Inn' },
  { code: 22, name: 'Lodge' },
  { code: 27, name: 'Motel' },
  { code: 5003, name: 'Love Hotel' },
  { code: 5005, name: 'Japanese-style Business Hotel' },
  { code: 5008, name: 'Capsule Hotel' },
]

export const bdcHomePropertyClassTypes = [
  { code: 3, name: 'Apartment' },
  { code: 4, name: 'Bed and Breakfast' },
  { code: 6, name: 'Camping' },
  { code: 7, name: 'Chalet' },
  { code: 12, name: 'Boat' },
  { code: 15, name: 'Farm stay' },
  { code: 33, name: 'Tented' },
  { code: 35, name: 'Villa' },
  { code: 40, name: 'Guest House' },
  { code: 5000, name: 'ApartHotel' },
  { code: 5001, name: 'Riad' },
  { code: 5002, name: 'Ryokan' },
  { code: 5004, name: 'Homestay' },
  { code: 5006, name: 'Holiday Home' },
  { code: 5007, name: 'Country house' },
  { code: 5009, name: 'Holiday Park' },
]

export const availablePropertyClassTypes = lodash.sortBy(
  [...bdcHomePropertyClassTypes, ...bdcHotelPropertyClassTypes],
  (t) => t.name
)

export enum BdcBathroomGroup {
  Home,
  Hotel,
}

// Booking.com property codes (booking_property_category), grouped as the Facilities API bathroom endpoints expect.
// Hostels (203) are not supported.
// https://developers.booking.com/connectivity/docs/content-api-modules/facilities-api/facilities-api-property-codes
const bdcHomeBathroomCodes = [201, 208, 209, 210, 212, 213, 214, 215, 216, 219, 220, 222, 223, 224, 227, 228]
const bdcHotelBathroomCodes = [204, 205, 206, 218, 221, 225, 226, 231, 234, 235]

export function getBdcBathroomGroup(bookingPropertyCategory: number): BdcBathroomGroup | null {
  if (bdcHomeBathroomCodes.includes(bookingPropertyCategory)) {
    return BdcBathroomGroup.Home
  }
  if (bdcHotelBathroomCodes.includes(bookingPropertyCategory)) {
    return BdcBathroomGroup.Hotel
  }
  return null
}
